import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Spinner } from 'wanderu-animations';
import { SearchResult } from 'wanderu-component-search-result';
import {
    tripSelectors,
    fetchTripAction,
} from 'wanderu-ducks-trips';
import {
    selectLocale,
} from 'wanderu-i18n';
import {
    buildAbsoluteUrl,
} from 'wanderu-utils';

import SoldOutTrip from '../../components/SoldOutTrip/SoldOutTrip';
import events from '../../components/events';

import styles from './Trip.scss';

class Trip extends React.Component {
    componentDidMount() {
        const {
            mode,
            tag,
            trip,
            tripId,
        } = this.props;

        // TODO: If fetchTrip fails, I should request a new tripid?
        if (!trip) {
            this.props.fetchTrip(tripId, mode, tag);
        }
    }

    buildTripsummaryPath() {
        const {
            arrivePlaceId,
            departPlaceId,
            locale,
            trip,
        } = this.props;

        const queries = {
            dpid: arrivePlaceId,
            opid: departPlaceId,
        };

        return buildAbsoluteUrl({
            href: `/${locale}/tripsummary/${encodeURIComponent(trip.tripId)}`,
            queries,
        });
    }

    onSelect = () => {
        const {
            index,
            totalTrips,
            trip,
            tripId,
        } = this.props;
        const price = Object.values(trip.pricing?.[0])?.[0];

        events.selectResult({
            position: index + 1,
            price,
            totalTrips,
            tripId,
        });

        window.open(this.buildTripsummaryPath(), '_blank');
    }

    render() {
        const {
            arriveAddr,
            className,
            departAddr,
            mode,
            notFound,
            searchUrl,
            tag,
            trip,
        } = this.props;
        let tags = tag === 'both'
            ? ['cheapest', 'fastest']
            : [tag];

        if (notFound) {
            return (
                <SoldOutTrip
                    arriveAddr={arriveAddr}
                    className={styles.container}
                    departAddr={departAddr}
                    mode={mode}
                    searchUrl={searchUrl}
                    tag={tag}
                />
            );
        }

        if (!trip) {
            return (
                <div className={`${className} ${styles.spinnerContainer}`}>
                    <Spinner className={styles.spinner} />
                </div>
            );
        }

        return (
            <SearchResult
                {...trip}
                className={`${className} ${styles.container}`}
                onSelect={this.onSelect}
                tags={tags}
            />
        );
    }
}

Trip.propTypes = {
    arriveAddr: PropTypes.string,
    arrivePlaceId: PropTypes.string,
    className: PropTypes.string,
    departAddr: PropTypes.string,
    departPlaceId: PropTypes.string,
    fetchTrip: PropTypes.func,
    index: PropTypes.number,
    locale: PropTypes.string,
    mode: PropTypes.string,
    notFound: PropTypes.bool,
    searchUrl: PropTypes.string,
    tag: PropTypes.string,
    totalTrips: PropTypes.number,
    trip: PropTypes.object,
    tripId: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
    const explorerState = state.explorer;
    const {
        tripId,
    } = ownProps;

    return {
        carriers: explorerState.carriers,
        locale: selectLocale(state),
        notFound: fetchTripAction.selectNotFound(state, tripId),
        trip: tripSelectors.selectTrip(state, tripId, 1, 0),
    };
}

const mapDispatchToProps = {
    fetchTrip: fetchTripAction.fetchTrip,
};

export { Trip };

export default connect(mapStateToProps, mapDispatchToProps)(Trip);
